<div id="banner-uploader" class="card p-4">
  <h3 style="font-weight: 700; color: #060e9f">
    รูป Banner<lifedi-require></lifedi-require>
  </h3>
  <nz-upload
    class="avatar-uploader"
    nzName="banner-uploader"
    nzListType="picture-card"
    [nzShowUploadList]="false"
    [nzBeforeUpload]="beforeUpload"
    [nzCustomRequest]="successRequest"
    (nzChange)="handleChange($event)"
    [(nzFileList)]="fileList"
    nzTooltipTitle="คลิกเพื่ออัปโหลดรูปภาพBannerของคุณ"
    nzTooltipPlacement="right"
    nz-tooltip
  >
    <ng-container *ngIf="!imageUrl">
      <i
        nz-icon
        nzType="plus-circle"
        nzTheme="outline"
        style="font-size: 40px; color: #878787"
      ></i
      ><br />
      <div class="ant-upload-text">
        คลิก + เพื่ออัปโหลดรูปภาพBannerของคุณ <br />
        ขนาด 1268x390 พิกเซล
      </div>
    </ng-container>

    <img
    id="banner-image"
      *ngIf="imageUrl"
      alt="banner-image"
      [src]="imageUrl"
      style="
        max-width: 1268px;
        max-height: 390px;
        width: 100%;
        height: auto;
      "
    />
  </nz-upload>
  <span>แนะนำให้ใช้รูปภาพขนาด 1268x390 พิกเซล</span>
  <div
    *ngIf="imageBanner.invalid && (imageBanner.dirty || imageBanner.touched)"
    class="alert alert-danger"
  >
    กรุณาอัปโหลดรูปภาพ Banner
  </div>
</div>
